import(/* webpackMode: "eager" */ "/opt/buildhome/repo/web-app/frontend/src/app/[locale]/(analysis)/analyze/page.tsx");
